// extracted by mini-css-extract-plugin
module.exports = {"UpdateIdeaForm":"UpdateIdeaForm_UpdateIdeaForm__eMw6P"};